import PropTypes from 'prop-types'
import classNames from 'classnames'
import moment from 'moment'
import { get } from 'lodash'

import BaseCard from '../../card'
import Typography from '../../typography'
import Icon from '../../icon'
import DownloadFullColorIcon from '../../icon/download-full-color.svg'
import TagName from '../../tagName'
import Download from '../action/download'
import See from '../action/see'
import { KIND_LABEL_MAP, KIND_COLOR_MAP, KIND_ICON_MAP } from '../constants'
import styles from '../../../../styles/bantrab/components/card.module.scss'

const Card = ({ resource, file, ...attrs }) => {
  const { className } = attrs
  attrs.className = classNames(className, {
    [styles.card]: true
  })
  const kindLabel = resource.kindLabel || KIND_LABEL_MAP[resource.kind]
  const hasFile = !!get(resource, 'document.meta.downloadUrl', null)

  return (
    <div {...attrs}>
      <TagName
        url={`/recursos/${resource.id}/${resource.meta.slug}`}>
        <BaseCard.Media
          className={classNames([
            'rounded-border',
            'flex',
            'flex-row',
            KIND_COLOR_MAP[resource.kind] || 'bg-gray-300'
          ])}
          backgroundIconColor={'opacity-10'}
          widgetLeft={
            <Icon
              width='100'
              height='100'
              className={'mt-6 ml-6'}
              svg={KIND_ICON_MAP[resource.kind] || DownloadFullColorIcon}
            />
          }
          widgetRight={
            <Typography
              tag={'h3'}
              weight={'black'}
              size={'five'}
              className={'m-6'}
              clamp={3}
              style={{ maxHeight: '6rem' }}>
              {resource.title}
            </Typography>
          }
        />
        <div className='flex flex-row justify-between items-center mt-4 mb-4'>
          <Typography
            tag={'span'}
            size={'three'}
            weight={'medium'}
            className={'text-green-500'}>
            {kindLabel}
          </Typography>
          <Typography
            tag={'span'}
            size={'two'}
            weight={'regular'}
            className={'text-gray-400'}>
            {moment(resource.meta.firstPublishedAt).format('DD/MM/YYYY')}
          </Typography>
        </div>

        <Typography
          clamp={2}
          tag={'h3'}
          size={'four'}
          weight={'bold'}
          className={'mb-2'}
          style={
            {
              minHeight: '3.5rem'
            }
          }>
          {resource.title}
        </Typography>

      </TagName>
      {
        hasFile
          ? <Download
            resource={resource} />
          : <See
            resource={resource} />
      }
    </div>
  )
}

Card.propTypes = {
  resource: PropTypes.object,
  file: PropTypes.any
}

export default Card
